// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CollapsableInviteYourColleague, {
    CollapsableInviteYourColleaguePresentationProps,
} from "@store/Library/Components/CollapsableInviteYourColleague";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { css } from "styled-components";

export interface InviteYourColleagueCTAProps extends WidgetProps {}

export interface InviteYourColleagueCTAStyles {
    collapsableInviteYourColleague?: CollapsableInviteYourColleaguePresentationProps;
}

const inviteYourColleagueCTAStyles: InviteYourColleagueCTAStyles = {
    collapsableInviteYourColleague: {
        extendedStyles: {
            wrapper: {
                css: css`
                    ${spacingStyles(pxToRem(70), null)}
                    margin-bottom: ${pxToRem(30)};
                `,
            },
        },
    },
};

const styles = inviteYourColleagueCTAStyles;

const InviteYourColleagueCTA: FC<InviteYourColleagueCTAProps> = () => {
    return <CollapsableInviteYourColleague {...styles.collapsableInviteYourColleague} />;
};

const widgetModule: WidgetModule = {
    component: InviteYourColleagueCTA,
    definition: {
        displayName: "Invite Your Colleague CTA",
        group: "Common",
    },
};

export default widgetModule;
